import { Layout } from 'antd';
import { Outlet } from 'react-router';

import { Header } from '../Header/Header';
import { Sidebar } from '../SideBar/Sidebar';

import styles from './MainLayout.module.scss';

export const MainLayout = () => (
  <Layout className={styles.wrapper}>
    <Sidebar />
    <Layout>
      <Header />
      <Layout.Content className={styles.content}>
        <Outlet />
      </Layout.Content>
    </Layout>
  </Layout>
);
